import {api} from '../api'

export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchReports: build.query({
      query(params) {
        return {
          url: `/report/`,
          method: 'GET',
          params: {
            ...params,
            ordering: '-created_at'
          }
        }
      },
    }),

    fetchReportById: build.query({
      query(payload) {
        return {
          url: `/report/${payload.id}/`,
          method: 'GET',
        }
      },
    }),

    createReport: build.query({
      query(payload) {
        return {
          url: `/report/`,
          method: 'POST',
          data: payload
        }
      },
    }),

    reportSetDownloaded: build.query({
      query(payload) {
        return {
          url: `/report/set_downloaded/`,
          method: 'POST',
          data: payload
        }
      },
    }),

    createExportSeller: build.query({
      query(payload) {
        const formData = new FormData()
        formData.append("report_type", payload.reportType);
        formData.append("merchant_id", payload.merchant_id);

        return {
          url: `/report/export_seller/`,
          method: 'POST',
          headers: {
            'Content-Type': 'multipart/form-data;'
          },
          data: formData,
        }
      },
    }),

    updateExportSeller: build.query({
      query(payload) {
        return {
          url: `/report/export_seller/`,
          method: 'PUT',
          data: payload
        }
      },
    }),

    deleteExportSeller: build.query({
      query(payload) {
        return {
          url: `/report/export_seller/${payload?.id}/`,
          method: 'DELETE',
        }
      },
    }),
  }),
})
